import React from 'react';

import { getTitleJobOpeningsStatesMapFileUrl } from '../../../services/mediaBucketS3Service';
import { WIDGET_NAMES } from '../../../utils/constant';

import StatesCountyMap from './index';

import classes from './index.module.css';

const TitleDemandStatesMap = (props) => {
  const { title } = props;
  const svgFileUrl = getTitleJobOpeningsStatesMapFileUrl(title);

  const gtmEventNames = {
    open: 'Title Job Openings Heatmap Modal Open',
  };
  const mapTooltip = {
    title: 'Jobs Openings',
    valueFormatFunc: (value) => value || 0,
  };
  const legendTooltip = {
    title: 'Job Openings',
    valueFormatFunc: (range, isLast) => {
      const rangeArr = range.split('-') || [];
      if (!rangeArr || !rangeArr.length) {
        return '';
      }
      return `${rangeArr[0]} - ${rangeArr[1]}${isLast ? '+' : ''}`;
    },
  };
  const legendLabelsCallback = (legendItems) => {
    if (!legendItems || !legendItems.length || !legendItems[0].rangeDisplay) {
      return <></>;
    }

    const minValue = legendItems[0].rangeDisplay.split('-')[0];
    const maxValue = legendItems[legendItems.length - 1].rangeDisplay.split('-')[1];

    return (
      <>
        <span className={classes['legend-label-part']}>
          <span className={classes['county-value']}>{minValue}</span>
          <span>Lowest</span>
        </span>
        <span className={classes['legend-label-part']}>
          <span>Highest</span>
          <span className={classes['county-value']}>{maxValue}</span>
        </span>
      </>
    );
  };

  return (
    <StatesCountyMap
      {...props}
      svgFileUrl={svgFileUrl}
      gtmEventNames={gtmEventNames}
      embedWidgetType={WIDGET_NAMES.TITLE_DEMAND_STATES_MAP}
      mapTooltip={mapTooltip}
      legendTooltip={legendTooltip}
      legendLabelsCallback={legendLabelsCallback}
    />
  );
};

export default TitleDemandStatesMap;
